import { render, staticRenderFns } from "./MagicTickerFill.vue?vue&type=template&id=8ec934b2&scoped=true&"
import script from "./MagicTickerFill.vue?vue&type=script&lang=js&"
export * from "./MagicTickerFill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec934b2",
  null
  
)

export default component.exports